import type { ReactNode } from 'react';
import type { ConversationThread, MessageAuthor } from './conversation';

export interface PropertyChange {
  key: string;
  label: string;
  before: ReactNode;
  after: ReactNode;
}
export type ObjectActivityEntry =
  | { id: string; kind: 'comment'; thread: ConversationThread }
  | { id: string; kind: 'change'; at: string; actor: MessageAuthor; changes: readonly PropertyChange[] };
export type ActivityFilter = 'all' | 'comments' | 'history';
export function filterActivity(entries: readonly ObjectActivityEntry[], filter: ActivityFilter) {
  return entries.filter(
    (e) => filter === 'all' || (filter === 'comments' ? e.kind === 'comment' : e.kind === 'change'),
  );
}
